import {Component, Input, OnInit} from "@angular/core";
import {ConfigStateService} from "../../../../../config/config-state.service";
import {Tenant} from "../../../../../../shared/types/tenant.enum";

declare var $: any;

@Component({
    selector: "table-column-toggle",
    templateUrl: "./table-column-toggle.component.html",
    styleUrls: ["./table-column-toggle.component.scss"],
    standalone: false
})
export class TableColumnToggleComponent implements OnInit {
  @Input() questions;

  showDropdown: boolean = false;
  showQuestionId: boolean;
  constructor(private config: ConfigStateService) {
  }

  ngOnInit() {
    this.showQuestionId = this.config.tenant !== Tenant.AU;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  hideDropdown() {
    this.showDropdown = false;
  }

  

}
